import { Dispatch, SetStateAction, useEffect } from 'react';
import { generatePath, useLocation, useNavigate, useParams } from 'react-router-dom';

import { TTabOption, TTrackUrlParam } from './tabs.types';

type Props = {
  tabs: TTabOption[];
  trackUrlParam?: TTrackUrlParam;
  activeIndex: number;
  setActiveIndex: Dispatch<SetStateAction<number>>;
};

const useTrackUrlParam = ({ tabs, trackUrlParam, activeIndex, setActiveIndex }: Props) => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const pathname = location.pathname;

  useEffect(() => {
    if (!tabs?.length) return;
    if (trackUrlParam?.type === 'param') {
      const key = trackUrlParam.key;
      const paramFromUrl = params[key];
      let _activeIndex = 0;
      const tabIsInTabs = tabs.find(({ value }, idx) => {
        if (value === paramFromUrl) {
          _activeIndex = idx;
          return true;
        }
        return false;
      });

      if (activeIndex === _activeIndex) {
        return;
      }

      if (!tabIsInTabs) {
        const url = generatePath(pathname, { [key]: tabs[0].value });
        navigate(url);
        return;
      }

      setActiveIndex(_activeIndex);
    }
  }, [activeIndex, navigate, params, pathname, setActiveIndex, tabs, trackUrlParam]);
};

export default useTrackUrlParam;
